module.exports = __webpack_public_path__ + "static/media/prepaid-empty-wallet.d88a6323.svg";